import { h } from 'preact';

export const PointsBadgeIcon = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    fill="none"
    viewBox="0 0 40 40"
    {...props}
  >
    <rect width="40" height="40" fill="url(#a)" rx="6" />
    <path
      fill="#e068b8"
      d="m15.1128 7.54035 1.552 1.97256-2.4623-.48707-1.9724 1.55216.487-2.46226-1.5523-1.97264 2.4625.48692 1.9726-1.55195z"
    />
    <path
      fill="#36e5b3"
      d="m30.0321 5.762 3.0756-1.41416-1.4142 3.07558 1.4142 3.07528-3.0756-1.41412-3.0756 1.41412 1.4142-3.07528-1.4142-3.07558z"
    />
    <path
      fill="#ffe14a"
      d="m22.6836 5.18206 1.814-.83422-.834 1.81404.834 1.81403-1.814-.83401-1.814.83401.834-1.81403-.834-1.81404zM32.6087 24.0781l1.3043-.5998-.5996 1.3043.5996 1.3044-1.3043-.5997-1.3043.5997.5996-1.3044-.5996-1.3043z"
    />
    <path
      fill="#fefefe"
      d="m20.3024 11.9879 2.117-.0831-1.5529 1.4412.0829 2.1169-1.441-1.5531-2.1171.0831 1.5529-1.441-.0829-2.1171zM31.1142 19.0873l1.1265-.0442-.8263.7669.0441 1.1264-.7668-.8265-1.1265.0442.8263-.7667-.0441-1.1265z"
    />
    <path
      fill="#000"
      fill-opacity=".1"
      d="M4.0796 1c-.40198 1.98438-.61346 4.03997-.61346 6.1459.00008 16.6786 13.24776 30.1993 29.59016 30.1995 1.6845 0 3.3361-.1464 4.9437-.4223C36.8491 38.1989 35.1884 39 33.3415 39H7.29085C3.81651 39 1 36.1649 1 32.6677V6.44536C1 4.12909 2.23579 2.10404 4.0796 1"
    />
    <defs>
      <linearGradient
        id="a"
        x1="20"
        x2="20"
        y1="0"
        y2="40"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#2ab4ff" />
        <stop offset="1" stop-color="#84ffad" />
      </linearGradient>
    </defs>
  </svg>
);
